import useUserStore from "../../../../stores/store";
import { getParsedNumber } from "../../../../utils/Common";

export default function ReportDetailsComponent({ data }) {
  const { user } = useUserStore();

  return (
    <section className="mb-5">
      {user.isSuperAdmin && (
        <div className="text-center text-lg font-semibold mb-5">
          {data.restaurantInfo.name} ({data.restaurantInfo.branch})
        </div>
      )}
      <div className="font-bold text-center mb-2">Order # {data.orderNumber}</div>
      {/* foods */}
      <div>
        {/* food-1 */}
        {data.foods?.map((food, idx) => (
          <div
            key={idx}
            className="flex items-center justify-between w-full space-x-[50px] font-p_regular min-h-[100px]
        border-t border-t-px border-t-[#707070]
        border-b border-b-px border-b-[#707070] font-p_regular"
          >
            <div className="w-[90%] leading-[21px]">
              {/* food */}
              <div className="flex items-center justify-between w-full text-[14px]">
                <h1 className="w-1/6 text-">{food.foodName}</h1>
                <p className="w-1/6 text-center text-[#341557]">Variation - {food.optionName}</p>
                <p className="w-1/6 text-center text-[#341557]">Qty x {food.quantity}</p>
                <p className="w-1/6 flex justify-end">
                  <span className="text-[#341557] w-[30%]">Price</span>
                  <span className="font-p_medium w-[70%] text-right">{food.unitPrice}TK</span>
                </p>
              </div>
              {/* food addons */}
              {food.addOns?.length > 0 &&
                food.addOns?.map((addOn, idx) => (
                  <div key={idx} className="flex items-center justify-between w-full text-[12px]">
                    <p className="w-1/6">{addOn.name}</p>
                    <p className="w-1/6 text-center"></p>
                    <p className="w-1/6 text-center">Qty x {food.quantity}</p>
                    <p className="w-1/6 flex justify-end">
                      <span className="text-[#341557] w-[30%]">Price</span>
                      <span className="font-p_medium w-[70%] text-right">{addOn.price}TK</span>
                    </p>
                  </div>
                ))}
            </div>
            <div className="w-[10%] text-right text-[16px]">
              <p>Total</p>
              <p className="font-p_semibold">{food.totalPrice} TK</p>
            </div>
          </div>
        ))}
      </div>
      {/* totals */}
      <div className="mt-[20px] flex justify-end w-full">
        <div className="w-[35vw]">
          <div
            className="flex justify-between text-[#341557] text-[16px] font-p_semibold
            leading-[25px]"
          >
            <h1>Subtotal</h1>
            <p>{data.foodPriceBeforeDiscount} tk</p>
          </div>
          
              <div className="my-[6px] border-b border-b-px border-b-[#341557]"></div>

          {/* Staff discount */}
          {data.staffDiscount != null && (
            <div>
              <div className="flex justify-between font-p_regular text-black text-[14px]">
                <p>
                  Staff Discount {data.staffDiscount.isDiscountInPercent ? `(${data.staffDiscount.discount}%)` : ""}
                </p>
                <p className="font-semibold">
                  {data.staffDiscount > 0 ? "-" : ""}
                  {data.staffDiscount.amount} TK
                </p>
              </div>
              <div className="my-[6px] border-b border-b-px border-b-[#341557]"></div>
            </div>
          )}
          {data.loyaltyDiscount != null && (
            <div>
              <div className="flex justify-between font-p_regular text-black text-[14px]">
                {data.loyaltyDiscount.discountType === "REDEEM"
                  ? `Points Redeemed (${data.loyaltyDiscount.redeemedPoints.toFixed(2)})`
                  : `Loyalty Discount (${data.loyaltyDiscount.discountPercent.toFixed(2)}%)`}
                <p className="font-p_regular">
                  {data.loyaltyDiscount.discountAmount > 0 ? "-" : ""}
                  {data.loyaltyDiscount.discountAmount.toFixed(2)} TK
                </p>
              </div>
              <div className="my-[6px] border-b border-b-px border-b-[#341557]"></div>
            </div>
          )}
          
          {data.couponDiscount  && (
            <div>
              <div className="flex justify-between font-p_regular text-black text-[14px]">
                <p>
                  Coupon Discount ({data.couponDiscount.couponCode})
                </p>
                <p className="font-p_regular">
                  - {data.couponDiscount.discountAmount.toFixed(2)} TK
                </p>
              </div>
              <div className="my-[6px] border-b border-b-px border-b-[#341557]"></div>
            </div>
          )}

          {/* vat service charge */}
          {!data.isSupplementaryDutyIncluded && (
            <div className="font-p_regular text-black text-[14px]">
              <div className="flex justify-between">
                <p>Supplementary Duty</p>
                <p>{data.sd} TK</p>
              </div>
            </div>
          )}
          {!data.isServiceChargeIncluded && (
            <div className="font-p_regular text-black text-[14px]">
              <div className="flex justify-between">
                <p>Service Charge ({data.serviceChargePercent}%)</p>
                <p>{data.serviceCharge} TK</p>
              </div>
            </div>
          )}
          {!data.isVatIncluded && (
            <div className="font-p_regular text-black text-[14px]">
              <div className="flex justify-between">
                <p>VAT ({data.vatPercent}%)</p>
                <p>{data.vat} TK</p>
              </div>
            </div>
          )}
          {!data.isVatIncluded && 
          <div className="my-[6px] border-b border-b-px border-b-[#341557]"></div>
          }
          <div
            className="flex justify-between text-[#341557] text-[16px] font-p_semibold
            leading-[25px]"
          >
            <h1>Paid Amount</h1>
            <p>{data.totalPrice} tk</p>
          </div>
          {(data.isVatIncluded || data.isSupplementaryDutyIncluded || data.isServiceChargeIncluded) && (
            <div className="font-p_regular text-black text-[14px]">Included</div>
          )}
          {data.isSupplementaryDutyIncluded && (
            <div className="font-p_regular text-black text-[14px]">
              <div className="flex justify-between">
                <p>Supplementary Duty</p>
                <p>{data.sd} TK</p>
              </div>
            </div>
          )}

          {data.isServiceChargeIncluded && (
            <div className="font-p_regular text-black text-[14px]">
              <div className="flex justify-between">
                <p>Service Charge ({data.serviceChargePercent}%)</p>
                <p>{data.serviceCharge} TK</p>
              </div>
            </div>
          )}
          {data.isVatIncluded && (
            <div className="font-p_regular text-black text-[14px]">
              <div className="flex justify-between">
                <p>VAT ({data.vatPercent}%)</p>
                <p>{data.vat} TK</p>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* payments */}
      <div className=" flex justify-end w-full mt-[30px]">
        <div className="w-[35vw]">
          <div
            className="flex justify-between text-[#341557] text-[16px] font-p_semibold
                leading-[25px]"
          >
            <h1>Payments</h1>
          </div>
          <div>
            <div className="my-[6px] border-b border-b-px border-b-[#4a464e]"></div>
            {data.payments.paymentMediums?.length > 0 &&
              data.payments.paymentMediums?.map((payment, idx) => (
                <div key={idx} className="flex justify-between font-p_regular text-black text-[14px]">
                  <p className="capitalize">{payment.method}</p>
                  <p className="font-semibold">{payment.amount} TK</p>
                </div>
              ))}
            <div className="my-[6px] border-b border-b-px border-b-[#4a464e]"></div>
          </div>
          <div className="flex justify-between font-p_regular text-black text-[14px]">
            <p>Total Paid</p>
            <p className="font-semibold">{data.payments?.totalPaidAmount} TK</p>
          </div>
          <div className="flex justify-between font-p_regular text-black text-[14px]">
            <p>Returned Amount</p>
            <p className="font-semibold">
              {data.payments?.returnAmount > 0 ? "-" : ""}
              {data.payments?.returnAmount} TK
            </p>
          </div>
          {getParsedNumber(data.payments?.rounded) !== 0 && (
            <div className="flex justify-between font-p_regular text-black text-[14px]">
              <p>Rounded</p>
              <p className="font-semibold">{data.payments?.rounded} TK</p>
            </div>
          )}
          <div className="my-[6px] border-b border-b-px border-b-[#341557]"></div>
        </div>
      </div>
    </section>
  );
}
